namespace $.$$ {
	export class $shm_hitalama_map_widget_float_table_pick extends $.$shm_hitalama_map_widget_float_table_pick {
		height_max() { return super.height_max() / this.Follower().zoom() }
	}
}
